import * as rules from './rules';

export default function (validation, context, value) {
  if (typeof validation === 'undefined' || validation === null)
    return {valid: true, failedRules:  []};
  if (typeof validation === 'function')
    return validation(context);
  if (typeof validation !== 'string') {
    return {
      valid: false,
      failedRules: {
        'unkownValidationType': 'Bitte überprüfen Sie das Feld.'
      }
    };
  }

  const validationRules = validation.split(',').map(str => str.trim());

  let failedRules = {};
  for (const ruleString of validationRules) {
    const modifiers = ruleString.split(':').map(str => str.trim());
    const rule = modifiers.splice(0, 1);

    if (modifiers.length) {
      //== global modifiers (for all rules)
      // if modifier
      let ifIndex = modifiers.indexOf('if')
      if (ifIndex !== -1 && modifiers[ifIndex+1]) {
        if (!context.formData[modifiers[ifIndex+1]]) {
          console.debug('skipping rule', ruleString)
          continue;
        }
      }

      // ifEquals modifier
      ifIndex = modifiers.indexOf('ifEquals');
      if (ifIndex !== -1 && modifiers[ifIndex+1] && modifiers[ifIndex+2]) {
        if(context.formData[modifiers[ifIndex+1]] !== modifiers[ifIndex+2]) {
          console.debug('skipping rule', ruleString)
          continue;
        }
      }
    }

    if (!rules[rule]) {
      failedRules[rule] = 'Bitte prüfen Sie Ihre Eingabe.';
      console.error('validation rule "%s" does not exist.', rule);
      continue;
    }

    const ruleResult = rules[rule](value, modifiers, context);
    if (!ruleResult.valid) {
      failedRules[rule] = ruleResult.errorMessage;
    }
  }

  return {
    valid: Object.keys(failedRules).length === 0,
    failedRules
  };
}
